import { render, staticRenderFns } from "./base-combobox.vue?vue&type=template&id=c8d93134"
import script from "./base-combobox.ts?vue&type=script&lang=ts&external"
export * from "./base-combobox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports